export default __webpack_public_path__ + "static/Estate-new-b7544202388ed81bfa110b99b0bae852.webp";